import React, { Component } from 'react';

class Answer extends Component {
    constructor(props) {
        super(props);
        // Ensure we always have default values
        const { initialValues = {} } = props;
        this.state = {
            label: initialValues.label !== undefined ? initialValues.label : '',
            value: initialValues.value !== undefined ? initialValues.value : ''
        };
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnChange(e) {
        const { name, value } = e.target;
        const { position } = this.props;
        console.log(name, value);
        // Update local state immediately for better UX
        this.setState({ [name]: value });
        
        // Notify parent of the change
        this.props.parentStateCallback({ [name]: value }, 'default', position);
    }
    render() {
        return (
            <React.Fragment>
                <div className="row alert alert-dark">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Respuesta</label>
                            <input
                                type="text"
                                name="label"
                                value={this.state.label || ''}
                                onChange={this.handleOnChange}
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="col-sm-3">
                        <div className="form-group">
                            <label>Valor</label>
                            <input
                                type="text"
                                name="value"
                                value={this.state.value || ''}
                                onChange={this.handleOnChange}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Answer;



// WEBPACK FOOTER //
// ./src/components/Survey/admin/EditFieldCollection/SingleMultipleAnswer.js